import axios from '@fs/zion-axios'
import { baseUrl } from '@fs/zion-config'

// Use baseUrl from zion-config for all axios relative path calls when running on ident subdomain so that Root calls can work (as cross-origin request).
axios.defaults.baseURL = baseUrl

export default axios.create()
